(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    root.classList.add('is-enhanced');
    const panels = [...root.querySelectorAll('[data-model-panel]')];
    const tabs = [...root.querySelectorAll('[data-model-tab]')];
    const modelNames = { juniper: 'Model Y Juniper', legacy: 'Model Y 2020–2025.03', standard: 'Model Y Standard', yl: 'Model YL' };
    const collectionUrls = { juniper: root.dataset.collectionJuniper, legacy: root.dataset.collectionLegacy, standard: root.dataset.collectionStandard, yl: root.dataset.collectionYl };
    let model = root.dataset.defaultModel || 'juniper';
    const track = (event, data = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, page_type: 'model_y_accessory_guide', selected_model: model, ...data });
    };
    const scrollProducts = () => root.querySelector('[id^="myg-products-"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const panelState = (panel) => {
      if (panel._mygState) return panel._mygState;
      const grid = panel.querySelector('[data-product-grid]');
      const cards = [...panel.querySelectorAll('[data-product-card]')];
      const filters = [...panel.querySelectorAll('[data-filter]')];
      const search = panel.querySelector('[data-search]');
      const sort = panel.querySelector('[data-sort]');
      const count = panel.querySelector('[data-result-count]');
      const resultLabel = panel.querySelector('[data-result-label]');
      const empty = panel.querySelector('[data-empty]');
      const loadMore = panel.querySelector('[data-load-more]');
      const state = { grid, cards, filters, search, sort, count, resultLabel, empty, loadMore, filter: 'all', expanded: false };
      panel._mygState = state;
      return state;
    };

    const apply = (panel, eventName = '') => {
      const s = panelState(panel);
      const query = (s.search?.value || '').trim().toLowerCase();
      let visible = 0;
      let matches = 0;
      let deferredMatches = 0;
      s.cards.forEach((card) => {
        const categoryMatch = s.filter === 'all' || (` ${card.dataset.categories} `).includes(` ${s.filter} `);
        const queryMatch = !query || card.dataset.title.includes(query);
        const match = categoryMatch && queryMatch;
        const deferred = match && !s.expanded && s.filter === 'all' && !query && Number(card.dataset.rank) > 8;
        card.hidden = !match;
        card.classList.toggle('is-deferred', deferred);
        if (match) matches += 1;
        if (deferred) deferredMatches += 1;
        if (match && !deferred) visible += 1;
      });
      s.filters.forEach((button) => {
        const active = button.dataset.filter === s.filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (s.count) s.count.textContent = String(visible);
      if (s.resultLabel) {
        const categoryLabel = s.filter === 'all' ? 'model-matched accessories' : `${s.filter} accessories`;
        s.resultLabel.textContent = visible < matches ? `of ${matches} ${categoryLabel}` : categoryLabel;
      }
      if (s.empty) s.empty.hidden = matches !== 0;
      if (s.loadMore) s.loadMore.hidden = s.expanded || deferredMatches === 0;
      if (eventName) track(eventName, { category: s.filter, query_length: query.length, visible_products: visible, total_matches: matches });
    };

    const setModel = (nextModel, options = {}) => {
      if (!modelNames[nextModel]) return;
      model = nextModel;
      panels.forEach((panel) => { panel.hidden = panel.dataset.modelPanel !== model; });
      tabs.forEach((tab) => {
        const active = tab.dataset.modelTab === model;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      root.querySelectorAll('[data-active-model-name]').forEach((el) => { el.textContent = modelNames[model]; });
      const collectionLink = root.querySelector('[data-active-collection-link]');
      if (collectionLink) collectionLink.href = collectionUrls[model];
      const panel = panels.find((item) => item.dataset.modelPanel === model);
      if (panel) apply(panel);
      try { sessionStorage.setItem('teseryModelYEdition', model); } catch (_) {}
      if (options.track !== false) track('model_y_edition_select', { selected_model: model, placement: options.placement || 'chooser' });
      if (options.scroll) scrollProducts();
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => setModel(tab.dataset.modelTab, { scroll: true })));
    root.querySelectorAll('[data-model-quick]').forEach((button) => button.addEventListener('click', () => setModel(button.dataset.modelQuick, { scroll: true, placement: 'hero' })));
    root.querySelector('[data-change-model]')?.addEventListener('click', () => root.querySelector('[id^="myg-chooser-"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));

    panels.forEach((panel) => {
      const s = panelState(panel);
      s.filters.forEach((button) => button.addEventListener('click', () => { s.filter = button.dataset.filter; s.expanded = false; apply(panel, 'model_y_category_filter'); }));
      let searchTimer;
      s.search?.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => { s.filter = 'all'; s.expanded = true; apply(panel, 'model_y_product_search'); }, 220); });
      s.sort?.addEventListener('change', () => {
        const modes = { best: (a,b) => Number(a.dataset.rank)-Number(b.dataset.rank), 'price-asc': (a,b) => Number(a.dataset.price)-Number(b.dataset.price), 'price-desc': (a,b) => Number(b.dataset.price)-Number(a.dataset.price), title: (a,b) => a.dataset.title.localeCompare(b.dataset.title) };
        s.cards.sort(modes[s.sort.value]).forEach((card) => s.grid.appendChild(card));
        s.expanded = true;
        apply(panel, 'model_y_product_sort');
      });
      s.loadMore?.addEventListener('click', () => { s.expanded = true; apply(panel, 'model_y_load_more'); });
      panel.querySelector('[data-reset]')?.addEventListener('click', () => { s.filter = 'all'; s.expanded = false; if (s.search) s.search.value = ''; apply(panel, 'model_y_filter_reset'); });
      s.cards.forEach((card) => card.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => track('model_y_product_click', { product_id: card.dataset.productId, position: Number(card.dataset.rank), destination: link.getAttribute('href') }))));
    });

    root.querySelectorAll('[data-priority]').forEach((button) => button.addEventListener('click', () => {
      const panel = panels.find((item) => item.dataset.modelPanel === model);
      if (!panel) return;
      const s = panelState(panel);
      s.filter = button.dataset.priority;
      s.expanded = false;
      apply(panel, 'model_y_priority_select');
      scrollProducts();
    }));
    root.querySelectorAll('[data-track]').forEach((link) => link.addEventListener('click', () => track('model_y_cta_click', { placement: link.dataset.track, destination: link.getAttribute('href') })));
    root.querySelectorAll('[data-quick-add]').forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      const label = button.querySelector('span');
      const original = label.textContent;
      button.disabled = true;
      label.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add');
        const item = await response.json();
        label.textContent = 'Added to cart';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        track('model_y_quick_add', { product_id: item.product_id, variant_id: item.variant_id, quantity: item.quantity });
        setTimeout(() => { label.textContent = original; button.disabled = false; }, 2200);
      } catch (_) {
        const productLink = form.closest('[data-product-card]')?.querySelector('h3 a');
        if (productLink) window.location.href = productLink.href;
      }
    }));

    let savedModel;
    try { savedModel = sessionStorage.getItem('teseryModelYEdition'); } catch (_) {}
    setModel(modelNames[savedModel] ? savedModel : model, { track: false });
    const mobileBar = root.querySelector('[data-mobile-bar]');
    if (mobileBar && 'IntersectionObserver' in window) {
      const hero = root.querySelector('.myg-hero');
      const footer = root.querySelector('.myg-final');
      const updateBar = () => {
        const afterHero = hero && hero.getBoundingClientRect().bottom < 80;
        const beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight * .75;
        mobileBar.classList.toggle('is-visible', afterHero && beforeFooter);
      };
      new IntersectionObserver(updateBar).observe(hero);
      new IntersectionObserver(updateBar).observe(footer);
      window.addEventListener('scroll', updateBar, { passive: true });
      updateBar();
    }
  };
  document.querySelectorAll('[data-model-y-guide]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-model-y-guide]').forEach(init));
})();
